import { initializeApp } from 'firebase/app'
import { getAuth, type Auth } from 'firebase/auth'
import {
  clearIndexedDbPersistence,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  terminate,
  type Firestore,
} from 'firebase/firestore'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

export const allowedEmail =
  import.meta.env.VITE_ALLOWED_EMAIL?.trim().toLocaleLowerCase('en-US') ||
  'vadim.mafik@gmail.com'

export const firebaseConfigured = Object.values(firebaseConfig).every(Boolean)

let auth: Auth | null = null
let firestore: Firestore | null = null

if (firebaseConfigured) {
  const app = initializeApp(firebaseConfig)
  auth = getAuth(app)
  firestore = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager(),
    }),
  })
}

export function getFirebaseServices(): { auth: Auth; firestore: Firestore } {
  if (!auth || !firestore) {
    throw new Error('Firebase не настроен для этой сборки.')
  }
  return { auth, firestore }
}

export async function clearFirestoreDeviceCache(): Promise<void> {
  if (!firestore) return
  await terminate(firestore)
  await clearIndexedDbPersistence(firestore)
}
